import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { FEATURED_PETITION_SLUG } from '../../constants';

import type { UkSurgingCardFeaturedPetitionQuery, UkSurgingCardFeaturedPetitionQueryVariables } from './api.graphql';
import { UkSurgingCardFeaturedPetition } from './api.graphql';

export type FeaturedPetition = NonNullable<UkSurgingCardFeaturedPetitionQuery['petition']>;

// Live client-side fetch of the hard-coded featured petition — deliberately outside pageUserData so
// signature counts are never served stale from the page cache. `petition` may be null (not found).
export async function getFeaturedPetition(
	utilityContext: UtilityContext,
): Promise<{ petition: UkSurgingCardFeaturedPetitionQuery['petition'] }> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<UkSurgingCardFeaturedPetitionQuery, UkSurgingCardFeaturedPetitionQueryVariables>({
		query: UkSurgingCardFeaturedPetition,
		variables: { slugOrId: FEATURED_PETITION_SLUG },
		// keep this live query out of the batched page-load queries
		batched: false,
		rejectOnError: true,
	});

	return { petition: data.petition };
}
